var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const/';
import Icons from '../icon/icon';
import DarkTooltip from '../tooltip/dark-tooltip';
var Overlay = function (props) { return (React.createElement("p", null,
    props.text,
    props.link && (React.createElement(HelpLink, { link: props.link },
        "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089",
        React.createElement("span", null,
            React.createElement(Icons.ExternalLink, null)))))); };
function Question(props) {
    var text = props.text, link = props.link, className = props.className, trigger = props.trigger, placement = props.placement, onVisibleChange = props.onVisibleChange, restProps = __rest(props, ["text", "link", "className", "trigger", "placement", "onVisibleChange"]);
    return (React.createElement("div", __assign({}, restProps),
        React.createElement(DarkTooltip, { overlay: React.createElement(Overlay, { text: text, link: link }), placementConfig: placementDarkConfig, trigger: trigger, placement: placement, onVisibleChange: onVisibleChange },
            React.createElement(Wrapper, null,
                React.createElement(Icons.Question, null)))));
}
var HelpLink = styled.a.attrs({
    href: function (props) { return props.link; },
    target: '_blank',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: underline;\n  white-space: nowrap;\n\n  > span {\n    display: inline-block;\n    margin-left: 5px;\n  }\n"], ["\n  color: ", ";\n  text-decoration: underline;\n  white-space: nowrap;\n\n  > span {\n    display: inline-block;\n    margin-left: 5px;\n  }\n"])), Color.WHITE);
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n"], ["\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n"])));
var targetOffset = [0, 0];
export var placementDarkConfig = {
    left: {
        points: ['cr', 'cl'],
        offset: [-12, 1],
        targetOffset: targetOffset,
    },
    right: {
        points: ['cl', 'cr'],
        offset: [12, 1],
        targetOffset: targetOffset,
    },
    top: {
        points: ['bc', 'tc'],
        offset: [1, -12],
        targetOffset: targetOffset,
    },
    bottom: {
        points: ['tc', 'bc'],
        offset: [1, 12],
        targetOffset: targetOffset,
    },
    topLeft: {
        points: ['bl', 'tl'],
        offset: [-7, -12],
        targetOffset: targetOffset,
    },
    leftTop: {
        points: ['tr', 'tl'],
        offset: [-12, -7],
        targetOffset: targetOffset,
    },
    topRight: {
        points: ['br', 'tr'],
        offset: [7, -12],
        targetOffset: targetOffset,
    },
    rightTop: {
        points: ['tl', 'tr'],
        offset: [12, -7],
        targetOffset: targetOffset,
    },
    bottomRight: {
        points: ['tr', 'br'],
        offset: [7, 12],
        targetOffset: targetOffset,
    },
    rightBottom: {
        points: ['bl', 'br'],
        offset: [12, 7],
        targetOffset: targetOffset,
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        offset: [-7, 12],
        targetOffset: targetOffset,
    },
    leftBottom: {
        points: ['br', 'bl'],
        offset: [-12, 7],
        targetOffset: targetOffset,
    },
};
export default Question;
var templateObject_1, templateObject_2;
//# sourceMappingURL=question.js.map